export const BOT_STATISTICS = {
    count: 0,
    average: 0,
    generalAverage: 0,
};
